import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetSavedFilters as GetSavedFiltersGenerated,
  GetSavedFiltersVariables as GetSavedFiltersVariablesGenerated,
  GetSavedFilters_savedTomFilters_filter as SavedFiltersFilterGenerated,
  GetSavedFilters_savedTomFilters as SavedFiltersGenerated,
} from "core/queries/__generated__/GetSavedFilters";

export interface GetSavedFiltersVariables
  extends GetSavedFiltersVariablesGenerated {}
export interface GetSavedFiltersResponse extends GetSavedFiltersGenerated {}
export interface SavedFilters extends SavedFiltersGenerated {}
export interface SavedFiltersFilter extends SavedFiltersFilterGenerated {}

export const getSavedFilters = gql`
  query GetSavedFilters($ownerId: ID!, $ownerType: FilterOwner!) {
    savedTomFilters(ownerId: $ownerId, ownerType: $ownerType) {
      id
      name
      description
      filter {
        assignee
        buildingIds
        city
        clientType
        dueAtEnd
        dueAtStart
        duringStay
        occupancy
        priority
        status
        taskType
        tomTags
        triaged
      }
    }
  }
`;

export interface UseGetSavedFiltersOptions {
  skip?: boolean;
  variables: GetSavedFiltersVariables;
}

export const useGetSavedFilters = ({
  skip,
  variables,
}: UseGetSavedFiltersOptions) =>
  useQuery<GetSavedFiltersResponse, GetSavedFiltersVariables>(getSavedFilters, {
    skip,
    fetchPolicy: "cache-and-network",
    variables,
  });
